var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessDocusign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#36B37E",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.468 33.83v3.425c-.01 16.488-10.864 31.007-26.677 35.682-15.813 4.675-32.818-1.607-41.793-15.44-8.975-13.832-7.782-31.92 2.932-44.454C19.644.51 37.326-3.486 52.388 3.225",
    transform: "translate(-681 -297) translate(683 299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.468 7.447L37.234 44.681 26.064 33.522",
    transform: "translate(-681 -297) translate(683 299)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessDocusign);
export default __webpack_public_path__ + "static/media/successDocusign.ffaa146e1d4ad66300387d7a337ffe90.svg";
export { ForwardRef as ReactComponent };